import { render, staticRenderFns } from "./PostFilter.vue?vue&type=template&id=4cc3c00f"
import script from "./PostFilter.vue?vue&type=script&lang=js"
export * from "./PostFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports